const dict = [
    ['Failed to fetch', '通信関係のエラーが発生しました'],
    ['timeout of ', '通信がタイムアウトしました'],
    ['duplicate key value violates unique constraint', '同じIDが既に登録済みです'],
    ['new row for relation "m_portioner_rate" violates check constraint "m_portioner_rate_allrate_check"', '比率の合計が1を超えています'],
    ['new row for relation "m_facility_auto_progress" violates check constraint "m_facility_auto_progress_check"', '作業者タグ連携のみONになっています'],

    ['target required','デプロイ先が未選択です'],
    ['source version required','Edgeバージョンが未選択です'],
    ['setting group required','加工処理グループが未選択です'],
    ['setting version required','加工処理グループバージョンが未選択です'],
    ['table required','テーブルが未選択です'],
    ['group required','グループ名が未入力です'],
    ['group invalid','グループ名が不正です'],
    ['version required','バージョン番号が未入力です'],
    ['process required','加工処理が未選択です'],

    ['NetworkError: A network error has occurred.', 'ネットワークエラー'],
    ['A network error has occurred.', 'ネットワークエラー'],

    ['Error: Deployment Completed. Please restart', 'デプロイが完了しました。再起動して反映してください'],
]
export default dict
